import { observable, action} from "mobx";
import {get,post,deleted,put} from "../services/ajax.service";

class AdminStore {
  @observable users = [];
  @observable limit = 10;
  @observable tiles = 0;
  @observable action = false;
  @observable errors = {};
  @observable url ="/api/v1/adminactions";

  @action setErrors = () => {
    this.errors = {};
  };

  @action setAction = action => {
    this.action = action;
  };

  @action getUsers = async data => {
    let entityData = [];
    if (data.type == "all_admins") {
      entityData = await get(
        `${this.url}/getall?limit=${this.limit}&&offset=${data.offset}&&search=${data.search}&&attr=${data.attr}`
      );
    }
    else {
      entityData = await get(
        `${this.url}/getall/${data.type}?limit=${this.limit}&&offset=${data.offset}&&search=${data.search}&&attr=${data.attr}`
      );
    }
    this.users = entityData.data.rows;
    let count = parseInt(entityData.data.count);
    this.tiles =
      count % this.limit == 0
        ? parseInt(count / this.limit)
        : parseInt(count / this.limit) + 1;
  };

  @action getUser = async id => {
    const getUser = await get(`${this.url}/get/${id}`);
    return getUser.data;
  };



  @action addUser = async (data, history) => {
    try {
      const Useradd = await post(`${this.url}/create`, data);
      console.log('UserADDD', JSON.parse(JSON.stringify(Useradd)))
      if(Useradd) {
        return Useradd
      }
      this.action = true;
      history.push("/portalmanagement/admins");
    } catch (e) {
      this.errors = e.response.data;
    }
  };

  @action deleteUser = async (id, history) => {
    try {
      await deleted(`${this.url}/delete/${id}`);
      var filtered = this.users.filter(user => user.id !== id);
      this.users = filtered;
    } catch (e) {
      console.log(e);
    }
  };
  @action editUser = async (data, history) => {
    try {
      await put(`${this.url}/update/${data.id}`, data);
      this.action = true;
      history.push("/portalmanagement/admins");
    } catch (e) {
      this.errors = e.response.data;
    }
  };


  @action enforceResetPassword = async (data) => {
    try {
      await put("/api/v1/secureAuthActions/enforceResetPassword",data);
      return;
    } catch (e) {
      console.log(e);
    }
  }
}

export default AdminStore;
